import {useRef} from 'react'
import {useLocation} from 'react-router-dom'
import {useAuth} from '../../lib/auth.jsx'
import {useToolAccess} from '../../lib/toolAccess.jsx'
import {useSessionGeneration} from '../../lib/useSessionGeneration.js'
import {packageBriefFromJob} from './artworkNativePackageRequest.js'
import SavedArtworkNativeRequest from './SavedArtworkNativeRequest.jsx'

export default function ArtworkNativePackageLaunch({job,dirty=false,busy=false,onRefresh}){
  const {user}=useAuth(),access=useToolAccess(),session=useSessionGeneration(),location=useLocation(),seen=useRef(new Set())
  const selection=packageBriefFromJob(job),allowed=access?.available('platform.artwork')===true&&access?.available('artwork')===true&&!dirty&&!busy
  const identity=JSON.stringify([session,user?.id,access?.data?.version,access?.data?.fingerprint,selection,job?.version,location.key,allowed])
  if(!selection)return null
  const returned=async(copyId,row)=>{const key=JSON.stringify([session,user?.id,selection,row.completedAssetId,copyId]);if(!seen.current.has(key)){seen.current.add(key);await onRefresh?.()}}
  return <section aria-label="Create artwork and prepared email">
    <h3>Create artwork and its prepared email</h3>
    <p>Use the saved brief and authorized source files once. The original and prepared email return to this same job; a request alone is not completed artwork.</p>
    {dirty?<p>Save or discard changed brief details before requesting artwork.</p>:<SavedArtworkNativeRequest key={identity} packageSelection={selection} actorId={user?.id} session={session} allowed={allowed} onPrepared={returned}/>}
    <button type="button" className="btn" disabled={busy} onClick={()=>onRefresh?.()}>Refresh saved artwork</button>
  </section>
}
